import { createDevStore } from 'bpm/shared/utils/devtools'
import { StateCreator, create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

export type ReasonsType = {
    reasons: Record<string, Array<string>>
    setReasons: (reasonsList: {
        noteType: string
        reasons: Array<string>
    }) => void
}

const store = createDevStore(
    persist(
        (set) => ({
            reasons: {},
            setReasons: ({ noteType, reasons }) =>
                set((state) => ({
                    reasons: {
                        ...state.reasons,
                        [noteType]: reasons,
                    },
                })),
        }),
        {
            name: 'note-reasons',
            storage: createJSONStorage(() => localStorage),
        }
    ) as StateCreator<ReasonsType, [], [['zustand/persist', unknown]]>,
    'NOTE_REASONS'
)

export const useNoteReasonsStore = create(store)
